import { useTopicGroup, useTopicsOptions } from "api/hooks";
import { routes } from "consts";
import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TopicGroupForm, TopicGroupFormValues } from "./TopicGroupForm/TopicGroupForm";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { PaziaLoader } from "components/atoms";
import { TanTableClient, TanTableColumn } from "components/molecules";
import { timeToMinutes } from "utils";
import { topicgroupsApi } from "api/topicgroups/topicgroupsApi";
import { useToaster } from "utils";
import { useTopicGroupAppearances } from "api/hooks/useTopicGroupAppearances";
import { TopicAppearanceApi } from "api";
import { PaziaBox } from "components/atoms";

export const TopicGroupEditPage = (): JSX.Element | null => {
  const { topicGroupId } = useParams();
  const { showSuccess, showError } = useToaster();
  const navigate = useNavigate();
  const { loading, data } = useTopicGroup(Number(topicGroupId));
  const { loading: loadingOptions, options } = useTopicsOptions(true);

  const onSubmit = async (data: TopicGroupFormValues) => {
    try {
      const request = {
        name: data.name,
        groupTime: timeToMinutes(data.groupTime) || undefined,
        courseGroupIds: data.courseGroupIds?.filter(Boolean).map((x) => +x!) ?? [],
        topics: data.topics.map((x) => ({ id: x.id!, time: x.time ?? undefined })),
      };
      await topicgroupsApi.update(Number(topicGroupId), request);
      navigate(routes.TOPICS_GROUPS);
      showSuccess("Grupa tematów została zaktualizowana.");
    } catch (error) {
      console.error(error);
      showError("Wystąpił błąd podczas aktualizacji grupy tematów.");
    }
  };

  if (loading || !data || loadingOptions || !options) return <PaziaLoader position="center" />;

  const breadcrumbs = [{ title: "Grupy tematów", path: routes.TOPICS_GROUPS }, { title: data.name }];

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edycja grupy tematów" />
      <TopicGroupForm onSubmit={onSubmit} topicOptions={options} topicGroup={data} />
      <TopicGroupAppearances topicGroupId={Number(topicGroupId)} />
    </PageMain>
  );
};

const TopicGroupAppearances = ({ topicGroupId }: { topicGroupId: number }) => {
  const { isLoading, appearances } = useTopicGroupAppearances(topicGroupId);
  return (
    <PaziaBox header="Wystąpienia w kursach" className="mt-2 md:mt-6">
      <TanTableClient data={appearances.course ?? []} columns={columns} pageSize={5} hideBorder />
    </PaziaBox>
  );
};
const columns: TanTableColumn<TopicAppearanceApi>[] = [
  {
    id: "courseId",
    hideOnMobile: true,
    header: "ID kursu",
    accessorKey: "courseId",
    size: 10,
    enableColumnFilter: false,
  },
  {
    id: "courseName",
    header: "Nazwa",
    accessorKey: "courseName",
    size: 500,
    enableColumnFilter: false,
  },
  {
    id: "actions",
    header: "",
    accessorKey: "courseId",
    enableColumnFilter: false,
    cell: (info) => (
      <Link target="_blank" to={routes.COURSES_EDIT_NESTED.SCHEDULE(info.getValue<number>())}>
        Zobacz
      </Link>
    ),
  },
];
